module.exports = __webpack_public_path__ + "img/DCOG.fc6bcf61.jpg";